export enum ProcedureIndexActionTypes {
  GET_PROCEDURE_INDEX_STATUS = "@@PROCEDURE_INDEX/GET_PROCEDURE_INDEX_STATUS",
  GET_PROCEDURE_INDEX_STATUS_SUCCESS = "@@PROCEDURE_INDEX/GET_PROCEDURE_INDEX_STATUS_SUCCESS",
  GET_PROCEDURE_INDEX_STATUS_FAILURE = "@@PROCEDURE_INDEX/GET_PROCEDURE_INDEX_STATUS_FAILURE",

  SET_FILTER = "@@PROCEDURE_INDEX/SET_FILTER",
  CLEAR = "@@PROCEDURE_INDEX/CLEAR",
}
